import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'social-login'

export const SocialLogin: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
